var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.954,66.651h-9.453V32.478c0-0.72-0.387-1.384-1.014-1.74l-9.044-5.129c-0.039-0.022-0.082-0.03-0.122-0.049 c-0.033-0.016-0.059-0.042-0.093-0.056c-0.04-0.017-0.083-0.017-0.123-0.031c-0.105-0.036-0.21-0.062-0.319-0.081 c-0.077-0.013-0.152-0.025-0.229-0.028c-0.108-0.005-0.214,0.003-0.322,0.015c-0.075,0.009-0.149,0.013-0.223,0.03 c-0.111,0.025-0.215,0.068-0.321,0.113c-0.065,0.027-0.132,0.047-0.195,0.081c-0.014,0.008-0.03,0.01-0.044,0.018 c-0.121,0.07-0.224,0.161-0.326,0.252c-0.023,0.021-0.051,0.032-0.073,0.053l-0.014,0.014c-0.001,0.001-0.001,0.001-0.002,0.002 L36.093,37.744c-0.38,0.375-0.594,0.888-0.594,1.422v27.485h-9.454c-1.104,0-2,0.896-2,2s0.896,2,2,2h11.454h11.958h9.044h11.453 c1.104,0,2-0.896,2-2S71.059,66.651,69.954,66.651z M39.499,49.917l7.958-7.959v4.125l-7.958,7.958V49.917z M39.499,59.698 l7.958-7.958v4.125l-7.958,7.958V59.698z M47.457,61.521v5.13h-5.13L47.457,61.521z M47.457,32.137v4.165l-7.958,7.959v-4.258 L47.457,32.137z M51.457,66.651V30.782l5.044,2.86v33.009H51.457z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.efbccacda64ced651166c4ac20bbc1c7.svg";
export { ForwardRef as ReactComponent };